import { CONFIG } from '~/_shared/constants/config';

export const getExportUrl = (url: string) => {
  return (CONFIG.API_URL ?? '') + url;
};
